import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "./AboutPart.css";
import FFcomStandard from "../assets/mock4.png";
import FFcomPremium from "../assets/mock2.png";

export default function AboutPart() {
    const [isPremium, setIsPremium] = useState(false);

    useEffect(() => {
        Aos.init({ duration: 1500, once: true });

        // restore premium preference if it exists
        const saved = localStorage.getItem("fixerfind_isPremium");
        if (saved === "true") setIsPremium(true);
    }, []);

    useEffect(() => {
        localStorage.setItem("fixerfind_isPremium", isPremium ? "true" : "false");
    }, [isPremium]);

    const togglePlan = () => setIsPremium(!isPremium);

    return (
        <section className="relative w-full py-16 px-6 md:px-12 lg:px-24 bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white rounded-3xl overflow-hidden shadow-2xl">

            {/* Premium Toggle */}
            <div className="flex flex-col items-center mb-12">
                <div className="flex items-center justify-between gap-4 bg-gray-700 px-5 py-2 rounded-full shadow-lg w-56">
                    <span className="text-sm font-medium">
                        {isPremium ? "Premium Plan" : "Standard Plan"}
                    </span>
                    <button
                        onClick={togglePlan}
                        className={`w-16 h-8 flex items-center p-1 rounded-full transition ${isPremium ? "bg-blue-500" : "bg-gray-400"
                            }`}
                        aria-pressed={isPremium}
                    >
                        <span
                            className={`block w-6 h-6 bg-white rounded-full shadow transform transition-transform ${isPremium ? "translate-x-8" : "translate-x-0"
                                }`}
                        />
                    </button>
                </div>
                <p className="mt-2 text-xs text-gray-300">
                    Toggle to explore {isPremium ? "Free Standard" : "Paid Premium"} plan.
                </p>
            </div>

            {/* Main Content */}
            <div
                data-aos="fade-up"
                className="flex flex-col md:flex-row items-center gap-12"
            >
                {/* Image Section */}
                <div className="md:w-1/2 flex justify-center relative">
                    <img
                        src={isPremium ? FFcomPremium : FFcomStandard}
                        alt={isPremium ? "Premium Plan" : "Standard Plan"}
                        className="rounded-3xl shadow-2xl w-80 md:w-[360px] transform transition-transform duration-700 hover:scale-105"
                    />
                    <div className="absolute -bottom-4 -right-6 w-36 h-36 bg-blue-500/30 rounded-full filter blur-3xl animate-pulse" />
                    <div className="absolute -top-6 -left-8 w-28 h-28 bg-purple-500/20 rounded-full filter blur-3xl animate-pulse" />
                </div>

                {/* Text Section */}
                <div className="md:w-1/2 space-y-6">
                    <h1 className="text-3xl md:text-4xl font-extrabold text-white">
                        How FixerFind works on{" "}
                        <span className="text-blue-400">{isPremium ? "Premium" : "Standard"}</span>{" "}
                        plan
                    </h1>

                    {/* Customer */}
                    <div className="bg-gray-800/50 p-6 rounded-2xl shadow-lg">
                        <h2 className="font-semibold text-lg mb-3 text-blue-300">As a Customer:</h2>
                        <ul className="list-disc list-inside space-y-2 text-gray-200 text-sm">
                            {isPremium ? (
                                <>
                                    <li>Pay a monthly subscription of <span>&#8358;</span>4,950 only ✅</li>
                                    <li>Get FES-AI voice assists in your hires ✅</li>
                                    <li>Receive priority support and faster responses ✅</li>
                                    <li>See real-time demand, supply, and pricing insights ✅</li>
                                </>
                            ) : (
                                <>
                                    <li>Type in the service you are looking for</li>
                                    <li>Receive progressive result of the closest provider</li>
                                    <li>Hire it or request a later schedule from provider</li>
                                    <li>Confirm the details and proceed to down payment</li>
                                    <li>Be instantly connected all the way of the work ✅</li>
                                </>
                            )}
                        </ul>
                    </div>

                    {/* Service Provider */}
                    <div className="bg-gray-800/50 p-6 rounded-2xl shadow-lg">
                        <h2 className="font-semibold text-lg mb-3 text-purple-300">As a Service Provider:</h2>
                        <ul className="list-disc list-inside space-y-2 text-gray-200 text-sm">
                            {isPremium ? (
                                <>
                                    <li>Pay a monthly subscription of <span>&#8358;</span>9,900 only 🚀</li>
                                    <li>Claim 100% commission on completed jobs 🚀</li>
                                    <li>Feature your business in premium search results 🚀</li>
                                    <li>See real-time demand, supply, and pricing insights 🚀</li>
                                </>
                            ) : (
                                <>
                                    <li>Create a service profile (this requires ID documents)</li>
                                    <li>Receive requests for immediate and later jobs</li>
                                    <li>Approve, Reject, or Bargain calculated prices</li>
                                    <li>FixerFind claims 30% commission on completed jobs</li>
                                    <li>Keep your business organized in a fast growing system 🚀</li>
                                </>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
